var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9808 0C14.7021 0 16.353 0.65848 17.5702 1.83058C18.7873 3.00268 19.4712 4.5924 19.4712 6.25C19.4712 7.9076 18.7873 9.49732 17.5702 10.6694C16.353 11.8415 14.7021 12.5 12.9808 12.5C11.2594 12.5 9.60856 11.8415 8.39137 10.6694C7.17419 9.49732 6.49038 7.9076 6.49038 6.25C6.49038 4.5924 7.17419 3.00268 8.39137 1.83058C9.60856 0.65848 11.2594 0 12.9808 0ZM12.9808 15.625C20.1526 15.625 25.9615 18.4219 25.9615 21.875V25H0V21.875C0 18.4219 5.80889 15.625 12.9808 15.625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileNew);
export default __webpack_public_path__ + "static/media/profile__new.3629af71.svg";
export { ForwardRef as ReactComponent };